import { quizRepository } from './repository';
import QuizServiceImpl from './service/QuizServiceImpl';

const quizService = new QuizServiceImpl(quizRepository);

export { quizService };
